import { createAction, props } from '@ngrx/store';

import { InspectionsType } from '@main-application/inspections/components/inspections-list/inspections-list.component';
import {
  InspectionSummaryAppliedFilters,
  InspectionSummaryFilters,
  InspectionSummaryStatsResponse,
} from '@main-application/inspections/models/legacy-inspection-summary.model';
import {
  BulkInspectionsRequestParams,
  DynamicSchedule,
  InspectionScheduleType,
  RestDynamicInspectionModel,
  RestInspectionsModel,
} from '@main-application/inspections/models/rest-inspections-model.interface';
import { RestAddInspectionTicket, RestUpdateInspectionTicket } from '@shared/interfaces/ticket.interface';
import {
  IInspectionFilterForm,
  InReviewInspectionFilterForm,
  RepeatingInspectionFilterForm,
} from '@template/interfaces/filter.interface';
import { RestTemplateModel } from '@template/models/rest-template-model.interface';
import {
  InspectionsSummaryStatsDetails,
  SummaryFilters,
  SummaryStatsGroup,
  SummaryStatsV2Filter,
  SummaryStatsV2Params,
} from '@ui-components/components/summary-expandable-table/summary-expandable-table.model';

import { InspectionHasIssues, InspectionsListConstants } from '../components/inspections-list/constants';

export const loadAllInspections = createAction(
  '[Inspections] Load all space template',
  props<{
    portfolioId: number;
    startDate?: string;
    endDate?: string;
    inspectionType?: InspectionsType;
    dynamicInspectionId?: number;
    returnStandardAndResidentBoth?: boolean;
    onlyArchived?: boolean;
    hasNonDefaultOrNaAnswersLeft?: InspectionHasIssues;
    periodDateSearchFields?: InspectionsListConstants.TimeWindow;
    inspectionByStatusFilter?: number;
    categoryIds?: number[];
    diligenceId?: number;
  }>()
);

export const loadAllInspectionsSuccess = createAction(
  '[Inspections] All space template loaded successfully',
  props<{ listItems: RestInspectionsModel[] }>()
);
export const loadAllInspectionsFailed = createAction('[Inspections] All space template loading failed');
export const clearAllInspections = createAction('[Inspections] clearAllInspections');

export const clearInspectionsData = createAction('[Inspections] Clear space template data');

export const loadResidentInspections = createAction('[Inspections] loadResidentInspections');
export const loadResidentInspectionsSuccess = createAction(
  '[Inspections] loadResidentInspectionsSuccess',
  props<{ listItems: RestInspectionsModel[] }>()
);
export const loadResidentInspectionsFailed = createAction('[Inspections] loadResidentInspectionsFailed');

export const loadTemplatesForUnitSuccess = createAction(
  '[Inspections] Load template for unit number success',
  props<{ list: RestTemplateModel[] }>()
);
export const loadTemplatesForUnitFailed = createAction('[Inspections] Load template for unit number failed');

export const setNewlyAddedInspection = createAction(
  '[Inspections] setNewlyAddedInspectionId',
  props<{ inspection: RestInspectionsModel | RestDynamicInspectionModel; inspectionType: InspectionScheduleType }>()
);
export const clearNewlyAddedInspectionId = createAction('[Inspections] clearNewlyAddedInspectionId');

export const loadDynamicInspections = createAction(
  '[Inspections] loadDynamicInspections',
  props<{ portfolioId: number }>()
);
export const loadDynamicInspectionsSuccess = createAction(
  '[Inspections] loadDynamicInspectionsSuccess',
  props<{ listItems: RestDynamicInspectionModel[] }>()
);
export const loadDynamicInspectionsFailed = createAction('[Inspections] loadDynamicInspectionsFailed');
export const clearDynamicInspections = createAction('[Inspections] clearDynamicInspections');

export const deleteDynamicInspection = createAction(
  '[Inspections] deleteDynamicInspection',
  props<{ inspectionId: number; dynamicallyScheduledOn: DynamicSchedule; portfolioId: number; stepName: string }>()
);
export const deleteDynamicInspectionSuccess = createAction(
  '[Inspections] deleteDynamicInspectionSuccess',
  props<{ inspectionId: number }>()
);
export const deleteDynamicInspectionFailed = createAction('[Inspections] deleteDynamicInspectionFailed');

export const clearDeletedDynamicInspectionId = createAction('[Inspections] clearDeletedDynamicInspectionId');

export const setRepeatingInspectionsFilter = createAction(
  '[Inspections] set repeating inspections filter',
  props<Partial<RepeatingInspectionFilterForm>>()
);

export const updateRepeatingInspectionsFilter = createAction(
  '[Inspections] update Repeating Inspections Filter',
  props<Partial<RepeatingInspectionFilterForm>>()
);

export const loadRepeatingInspections = createAction(
  '[Inspections] loadRepeatingInspections',
  props<{ portfolioId: number; onlyArchived?: boolean }>()
);
export const loadRepeatingInspectionsSuccess = createAction(
  '[Inspections] loadRepeatingInspectionsSuccess',
  props<{ listItems: RestInspectionsModel[] }>()
);
export const loadRepeatingInspectionsFailed = createAction('[Inspections] loadRepeatingInspectionsFailed');

export const loadBulkInspections = createAction(
  '[Inspections] loadBulkInspections',
  props<{ params: BulkInspectionsRequestParams }>()
);
export const loadBulkInspectionsSuccess = createAction(
  '[Inspections] loadBulkInspectionsSuccess',
  props<{ listItems: RestInspectionsModel[] }>()
);
export const loadBulkInspectionsFailed = createAction('[Inspections] loadBulkInspectionsFailed');

export const setBulkInspectionFilter = createAction(
  '[Inspections] setBulkInspectionFilters',
  props<Partial<IInspectionFilterForm>>()
);

export const deleteRepeatingInspection = createAction(
  '[Inspections] deleteRepeatingInspection',
  props<{ inspectionId: number }>()
);
export const deleteRepeatingInspectionSuccess = createAction(
  '[Inspections] deleteRepeatingInspectionSuccess',
  props<{ inspectionId: number }>()
);
export const deleteRepeatingInspectionFailed = createAction('[Inspections] deleteRepeatingInspectionFailed');

export const clearDeletedRepeatingInspectionId = createAction('[Inspections] clearDeletedRepeatingInspectionId');

export const clearRepeatingInspections = createAction('[Inspections] clearRepeatingInspections');

export const setInspectionsFilter = createAction(
  '[Inspections] setInspectionsFilter',
  props<Partial<IInspectionFilterForm>>()
);

export const updateInspectionsFilter = createAction(
  '[Inspections] updateInspectionsFilter',
  props<Partial<IInspectionFilterForm>>()
);

export const addInspectionTicket = createAction(
  '[Inspections] addInspectionTicket',
  props<{ ticket: RestAddInspectionTicket }>()
);
export const addInspectionTicketSuccess = createAction('[Inspections] addInspectionTicketSuccess');
export const addInspectionTicketFailed = createAction('[Inspections] addInspectionTicketFailed');

export const updateInspectionTicket = createAction(
  '[Inspections] updateInspectionTicket',
  props<{ ticket: RestUpdateInspectionTicket }>()
);
export const updateInspectionTicketSuccess = createAction('[Inspections] updateInspectionTicketSuccess');
export const updateInspectionTicketFailed = createAction('[Inspections] updateInspectionTicketFailed');

// Inspection Summary Report
export const loadInspectionSummaryReport = createAction(
  '[Inspections] loadInspectionSummaryReport',
  props<{ filter: InspectionSummaryFilters }>()
);

export const loadInspectionSummaryReportSucceeded = createAction(
  '[Inspections] Load all inspection summary report succeeded',
  props<{ payload: InspectionSummaryStatsResponse; filter: InspectionSummaryFilters }>()
);

export const loadInspectionSummaryReportFailed = createAction('[Inspections] loadInspectionSummaryReport failed');

export const setSummaryReportAppliedFilter = createAction(
  '[Inspections] set Applied Filters',
  props<{ appliedFilters: InspectionSummaryAppliedFilters }>()
);

export const setInReviewInspectionsFilter = createAction(
  '[Inspections] set in review inspections filter',
  props<Partial<InReviewInspectionFilterForm>>()
);

export const loadInReviewInspections = createAction(
  '[Inspections] Load in review inspections',
  props<{
    portfolioId: number;
    isResident?: boolean;
    returnStandardAndResidentBoth?: boolean;
    onlyArchived?: boolean;
  }>()
);

export const loadInReviewInspectionsSuccess = createAction(
  '[Inspections] Load in review inspections success',
  props<{ inReviewListItems: RestInspectionsModel[] }>()
);
export const loadInReviewInspectionsFailed = createAction('[Inspections] Load in review inspections error');
export const clearInReviewInspections = createAction('[Inspections] clear in review inspections');

export const loadInspectionsSummaryStats = createAction(
  '[Inspections] Load Inspections Summary Stats',
  props<{ filter: SummaryFilters }>()
);

export const loadInspectionsSummaryStatsSuccess = createAction(
  '[Inspections] Load Inspections Summary Stats Success',
  props<{ stats: SummaryStatsGroup[] }>()
);

export const loadInspectionsSummaryStatsFailed = createAction(
  '[Inspections] Load Inspections Summary Stats Failed',
  props<{ error: any }>()
);

export const loadInspectionsSummaryDetails = createAction(
  '[Inspections] Load Inspections Summary Details',
  props<{ filter: SummaryFilters }>()
);

export const loadInspectionsSummaryDetailsSuccess = createAction(
  '[Inspections] Load Inspections Summary Details Success',
  props<{ details: InspectionsSummaryStatsDetails }>()
);

export const loadInspectionsSummaryDetailsFailed = createAction(
  '[Inspections] Load Inspections Summary Details Failed',
  props<{ error: any }>()
);

export const loadInspectionsSummaryStatsV2 = createAction(
  '[Inspections] Load Inspections Summary Stats V2',
  props<{ query: SummaryStatsV2Params; filters: SummaryStatsV2Filter[] }>()
);

export const loadInspectionsSummaryStatsV2Success = createAction(
  '[Inspections] Load Inspections Summary Stats V2 Success',
  props<{ stats: SummaryStatsGroup[] }>()
);

export const loadInspectionsSummaryStatsV2Failed = createAction(
  '[Inspections] Load Inspections Summary Stats V2 Failed',
  props<{ error: any }>()
);

export const loadInspectionsSummaryStatsV2Secondary = createAction(
  '[Inspections] Load Inspections Summary Stats V2 Secondary',
  props<{ query: SummaryStatsV2Params; filters: SummaryStatsV2Filter[] }>()
);

export const loadInspectionsSummaryStatsV2SecondarySuccess = createAction(
  '[Inspections] Load Inspections Summary Stats V2 Secondary Success',
  props<{ stats: SummaryStatsGroup[] }>()
);

export const loadInspectionsSummaryStatsV2SecondaryFailed = createAction(
  '[Inspections] Load Inspections Summary Stats V2 Secondary Failed',
  props<{ error: any }>()
);

export const loadInspectionsSummaryDashboardStatsV2 = createAction(
  '[Inspections] Load Inspections Summary Dashboard Stats V2',
  props<{ query: SummaryStatsV2Params; filters: SummaryStatsV2Filter[] }>()
);

export const loadInspectionsSummaryDashboardStatsV2Success = createAction(
  '[Inspections] Load Inspections Summary Dashboard Stats V2 Success',
  props<{ stats: SummaryStatsGroup[] }>()
);

export const loadInspectionsSummaryDashboardStatsV2Failed = createAction(
  '[Inspections] Load Inspections Summary Dashboard Stats V2 Failed',
  props<{ error: any }>()
);
